import { useTranslation } from "react-i18next";
import { ClockIcon } from "@/shared/icons";
import BadgeAvita from "@/shared/widgets/BadgeAvita";
import BadgeSale from "@/shared/widgets/BadgeSale";
import getBusinessImage from "@/domains/business/helpers/getBusinessImage";

type Props = {
  id: number;
  isAvita: boolean;
  isSale?: boolean;
  feeDays?: number;
};

export default function BusinessModalWiew({ id, isAvita, isSale, feeDays }: Props) {
  const { t } = useTranslation("business");

  const src = id ? getBusinessImage(id) : "";

  return (
    <div
      className="relative w-full h-60 mb-5 bg-cover bg-no-repeat rounded-2xl overflow-clip"
      style={{ backgroundImage: `url(${src})` }}
    >
      {isSale && !isAvita && <BadgeSale text={t("business.sale")} color="lightBlue" />}
      {isAvita && <BadgeAvita variant="lightBlue" className="rounded-tr-2xl" />}
      {typeof feeDays === "number" && (
        <div className="absolute top-2.5 left-2.5 flex items-center gap-2.5 h-11 px-3.5 rounded-2xl">
          <div
            aria-hidden
            className="absolute inset-0 rounded-2xl bg-dark-900/60 backdrop-blur-[5px]"
          />
          <ClockIcon className="relative z-1 size-5 shrink-0" />
          <div className="relative z-1 flex items-center gap-2.5">
            <div className="text-15 font-medium">{t("business.feePaid")}:</div>
            <div className="w-px h-2.5 bg-white/20" />
            <div className="text-16 font-bold">{t("business.days", { count: feeDays })}</div>
          </div>
        </div>
      )}
    </div>
  );
}
